import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

import { UiService } from "@services/ui.service";
import { WaitingTimesService } from "@services/waiting-times.service";
import { WaitingTime } from "@classes/waiting-time";


@Injectable()
export class WaitingTimesResolver {
  constructor(
    private waitingTimesSrv: WaitingTimesService,
    private uiSrv: UiService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<WaitingTime[]> {
    this.uiSrv.routeLoadingStateChanged.next(true);

    return this.waitingTimesSrv.get()
      .pipe(
        tap(() => {
          this.uiSrv.routeLoadingStateChanged.next(false);
        })
      );
  }
}
